import { useMemo } from 'react'
import { HistoryCharts } from './HistoryCharts'
import { useHistory } from '../hooks/useHistory'
import '../styles/history.css'

/**
 * v1.3.0 — the last 6 hours on the Live view, as a compact power chart,
 * following live data every minute. Links to the full History page.
 */
export function RecentStrip({ systemId, onOpenHistory }: { systemId: number; onOpenHistory: () => void }) {
  const range = useMemo(() => {
    const now = Math.floor(Date.now() / 1000)
    return { from: now - 6 * 3600, to: 'now' as const, key: `recent-${systemId}` }
  }, [systemId])
  const { state } = useHistory(systemId, range)

  if (state.status === 'error') return null       // the Live view stands on its own
  return (
    <section className="card recent-strip" aria-labelledby="recent-title">
      <div className="card-heading">
        <h2 id="recent-title">Last 6 hours</h2>
        <button type="button" className="link-button" onClick={onOpenHistory}>View history</button>
      </div>
      {state.status === 'loading' && <p className="history-message muted">Loading…</p>}
      {state.status === 'ready' && state.points.t.length > 0 && <HistoryCharts series={state.series} compact />}
      {state.status === 'ready' && state.points.t.length === 0 && (
        <p className="history-message muted">No readings in the last 6 hours.</p>
      )}
    </section>
  )
}
